exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".admin-login[data-v-99bff0ca]{min-height:100vh;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background:#f0f2f5}.login-card[data-v-99bff0ca]{width:360px}.login-title[data-v-99bff0ca]{font-size:18px;font-weight:700;text-align:center}.login-btn[data-v-99bff0ca]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-99bff0ca","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/views/Login.vue
// module id = 149
// module chunks = 0